import PlaceholderScreen from '@/karehero-app/tell-us-once/intake/PlaceholderScreen';
import { AI_CONSENT_DECLINED } from '@/karehero-app/tell-us-once/intake/content';

// Where "No thanks" lands. The path exists because the consent has to be
// refusable, but what it offers instead is an open question, so this is drawn as
// a stop rather than guessed at.
const AiConsentDeclinedScreen = () => (
  <PlaceholderScreen
    title={AI_CONSENT_DECLINED.title}
    note={AI_CONSENT_DECLINED.note}
  />
);

export default AiConsentDeclinedScreen;
